

/**
 * @info productType
 */
export const GENERIC = "generic"
export const FOOD_BEWERAGE = "foodbewerage";
export const TEXTILE = "textile";
export const SOFTWARE = "software"